import { LocalizedLanguage } from './LocalizedLanguage';

const localizedLanguage = new LocalizedLanguage();
const lang = localizedLanguage.localizedStringValues;
export default lang;
